import { useBooleanFlagValue } from '@openfeature/react-sdk';

import type { FlagKey } from './flagKeys';

export const useFeatureFlag = (key: FlagKey, defaultValue = false): boolean =>
  useBooleanFlagValue(key, defaultValue);
